module.exports = __webpack_public_path__ + "img/6E7181_D1CFDF_ABAFC7_B4BCCE-256px.de7a70b8.png";